document.addEventListener("DOMContentLoaded", function () {
    var elem = document.querySelectorAll(".clps-slider-carousel");
  
    elem.forEach((element) => {
      if (!element.classList.contains("flickity-enabled")) {
        var flkty = new Flickity(element, {
          // options
          cellAlign: "left",
          contain: true,
        });

        element.classList.add("flickity-enabled")
      }
    });
  });
  